import React from "react";
import PropTypes from "prop-types";

import ForecastsTableRecursiveRow from "./forecasts_table_recursive_row";

class ForecastsTableContainer extends React.Component {
  render () {
    const showDisclaimer = this.props.showDisclaimer;
    let expanded = this.props.tableData.length < 2;
    let digital = this.props.tableData[0] && this.props.tableData[0].digital;
    let sYR = this.props.sevenYearRange;
    let trs = this.props.tableData.map((row) => (<ForecastsTableRecursiveRow sevenYearRange={sYR} digital={digital} key={row.id} row={row} level={0} expanded={expanded} />));
    let yearHeadings = [];
    let yearHeadingIndex = 3;
    let startYearHeading = this.props.startYearHeading;

    while (yearHeadingIndex < 3 + sYR.length) {
      let key = "heading-" + yearHeadingIndex;
      let year = startYearHeading + yearHeadingIndex - 3;
      let el = <div key={key} className="number-wrapper th">{year}</div>;
      yearHeadings.push(el);
      yearHeadingIndex = yearHeadingIndex + 1;
    }
    let totalRow;

    if (this.props.extraTotalRow) {
      if (this.props.extraTotalRow[0]) {
        totalRow = [
          <ForecastsTableRecursiveRow sevenYearRange={sYR} digital={digital} key="table-total-1" row={this.props.extraTotalRow[0]} level={0} expanded={expanded} emphasize={true} />,
          <ForecastsTableRecursiveRow sevenYearRange={sYR} digital={digital} key="table-total-2" row={this.props.extraTotalRow[1]} level={0} expanded={expanded} emphasize={true} />
        ];
      } else {
        totalRow = <ForecastsTableRecursiveRow sevenYearRange={sYR} digital={digital} key="table-total" row={this.props.extraTotalRow} level={0} expanded={expanded} emphasize={true} />;
      }
    }

    return (
      <div className="react-forecasts-table">
        <div key="headings" className="headings">
          <div className="th" key="heading-1">Country / region</div>
          <div className="th" key="heading-2">Category</div>
          {yearHeadings}
          <div key="heading-11" className="number-wrapper th">5-Year CAGR</div>
        </div>
        <div key="body" className="body">
          {trs}
          {totalRow}
        </div>
        {
          showDisclaimer &&
            <div key="disclaimer" className="disclaimer">
              DISCLAIMER: These numbers have been adjusted to avoid duplicating discrete technology spending included in multiple technology areas or spending on specific components included in systems spending. The region 'Rest of the World' only includes spending on digital services for utilities where we have not been able to quantify the size of the market outside Western Europe and North America, such as GIS and mapping, data management/analysis and in-pipe inspection.
            </div>
        }
      </div>
    );
  }
}

ForecastsTableContainer.propTypes = {
  tableData: PropTypes.arrayOf(PropTypes.object).isRequired,
  startYearHeading: PropTypes.number.isRequired,
  sevenYearRange: PropTypes.arrayOf(PropTypes.number).isRequired,
  showDisclaimer: PropTypes.bool,
  extraTotalRow: PropTypes.object
};

export default ForecastsTableContainer;
